import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { PurposeOfBankAccountOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const PurposeOfBankAccountSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(PurposeOfBankAccountOptions).map((key) => ({
        id: key,
        label: t(`intake_form.purpose_of_bank_accounts.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default PurposeOfBankAccountSelect;
